import type { RouteLocation, RouteLocationRaw, RouteRecordRaw } from "vue-router";
import { DEFAULT_CLIENT_SECTION, legacyClientTabToSection } from "./Detail/clientSections";

function clientDetailRedirect(to: RouteLocation): RouteLocationRaw {
  const { clientTab, ...query } = to.query;
  return {
    name: "client-detail",
    params: {
      clientId: to.params.clientId,
      section: legacyClientTabToSection(clientTab) ?? DEFAULT_CLIENT_SECTION,
    },
    query,
  };
}

export const ClientRoutes: RouteRecordRaw[] = [
  {
    // `:dialog?` lets the overviews inside a section deep-link their own edit dialogs
    path: "/clients/:clientId(\\d+)/:section/:dialog?",
    name: "client-detail",
    component: () => import("./Detail/ClientDetailView.vue"),
  },
  {
    // The old edit dialog lived on `/clients/<id>?clientTab=<n>`
    path: "/clients/:clientId(\\d+)",
    name: "client-detail-root",
    redirect: clientDetailRedirect,
  },
  {
    path: "/clients",
    name: "clients",
    component: () => import("@cms/features/Clients/ClientsContainer.vue"),
    redirect: { name: "client-overview" },
    children: [
      {
        path: "/:catchAll(.*)",
        redirect: { name: "client-overview" },
      },
      {
        path: ":dialog?",
        name: "client-overview",
        component: () => import("./ClientsOverview.vue"),
      },
    ],
  },
];
